<template>
  <div class="chose_user">
    <h2 class="title" v-if="show">选择登录的用户</h2>
    <div class="user_content">
      <el-radio v-model="choseSign" :label="v.choseSign" :border="true" v-for="(v,i) in userList" :key="i">
        {{v.userType==3?(v.nickName || v.mobile || v.userName):v.userName}}
      </el-radio>
    </div>
    <el-button v-if="show" type="primary" :loading="loading" :disabled="choseSign?false:true" @click="loginBySign">确定</el-button>
  </div>
</template>

<script>
import { setLogin } from "@/pages/publicUtils/setLogin";
export default {
  props: {
    LoginCheckByCode: {
      type: Function,
      default: () => {},
    },
    LoginCheckBySign: {
      type: Function,
      default: () => {},
    },
    isShopView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      loading: false,
      userList: [],
      choseSign: "",
    };
  },
  mounted() {
    // console.log(this.$route.query);
    // console.log(this.$route.fullPath);
    let query = Object.assign({}, this.$route.query);
    // 店铺微信登录，先进多比微信登陆，再重定回店铺微信登录
    if (query.shopHost) {
      window.location.href = `${query.shopHost}/wxLogin?redirect=${query.redirect}&code=${query.code}&state=${query.state}`;
      return;
    }
    if (query.redirect == "undefined") query.redirect = undefined;
    this.loginByCode(query);
  },
  methods: {
    loginByCode(query) {
      let params = {
        wxCode: query.code,
        wxState: query.state,
        loginType: 0, //平台_商家_C端 = 0,平台_商家 = 1,商家 = 2 C端 = 3,
        clientType: this.isShopView ? 6 : 0, //pc=0 小程序=1 h5=5 pc_shop=6
      };
      this.LoginCheckByCode(params).then((res) => {
        // console.log("根据code登录", res);
        if (res.data[0].isChoseUser == 1) {
          this.show = true;
          this.userList = res.data[0].userList;
        } else {
          this.loginRes(res.data[0].tokenInfo);
        }
      });
    },
    loginBySign() {
      this.loading = true;
      let params = {
        choseSign: this.choseSign,
        loginType: 0, //平台_商家_C端 = 0,平台_商家 = 1,商家 = 2 C端 = 3,
        clientType: this.isShopView ? 6 : 0, //pc=0 小程序=1 h5=5 pc_shop=6
      };
      this.LoginCheckBySign(params)
        .then((res) => {
          // console.log("根据sign登录", res);
          this.loading = false;
          this.loginRes(res.data[0].tokenInfo);
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    loginRes(tokenInfo) {
      setLogin(tokenInfo).then(() => {
        let redirect = this.$route.query.redirect || "/";
        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!跳出iframe
        window.top.location = redirect;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.chose_user {
  display: flex;
  flex-direction: column;
  .title {
    text-align: center;
    margin-bottom: 30px;
  }
  .user_content {
    max-height: 240px;
    padding: 0 30px;
    overflow: auto;
  }
  .el-radio {
    margin: 0 0 10px 0 !important;
    width: 100%;
  }
  .el-button {
    margin: 0 30px;
    margin-top: 20px;
  }
}
</style>>